/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=03af4586&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=03af4586&lang=less&scoped=true"

import exportComponent from "/Users/zhangheng/Desktop/development/officialwebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03af4586"]])

export default __exports__